window.addEventListener("load", (event) => {
  load();
});
const load = () => {
  const select = document.getElementById("trainer-select");
  select.onchange = function (e) {
    selectedValue = e.target.value;
    resetFilter();
    if (selectedValue !== "") {
      setFilter(selectedValue);
    }
  };
};

const setFilter = (value) => {
  const lessonBlocks = document.querySelectorAll(`.lesson-block`);
  // トレイナー以外のboxを取得
  const notSelectedBlocks = Array.from(lessonBlocks).filter((block) => {
    if (block.querySelector(".name-item") === null) return false;
    return block.querySelector(".name-item").textContent !== value;
  });
  notSelectedBlocks.forEach(function (block) {
    block.classList.add("disabled-block");
  });
};

const resetFilter = () => {
  const lessonBlocks = document.querySelectorAll(`.lesson-block`);
  lessonBlocks.forEach(function (block) {
    block.classList.remove("disabled-block");
  });
};
